import { tw } from '@/utils/tw';
import BaseBoxTheme from 'base/components/Box/theme';

const Box = tw.theme({
  extend: BaseBoxTheme,
  base: `[&.col-span-12:has(article)]:-mx-3 [&.col-span-12:has(article)]:sm:-mx-0`,
});

export default Box;
